import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import ComponenteCtaPersonaJuridicaPresolicitud from '../components/ComponenteCtaPersonaJuridicaPresolicitud';
import { PERSONA_JURIDICA_BANNER } from '../Constantes';
import { Info } from '../components/Info';
import { infoCtaPersonaJuridicaList } from '../components/Listas';





export const CtaPersonaJuridicaPresolicitud: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={PERSONA_JURIDICA_BANNER} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Cuentas para Personas Jurídicas'} ></Title>
                                <Info infoList={infoCtaPersonaJuridicaList} info={'Pedí online tu cuenta corriente y disfrutala gratis por 6 meses. Además, podés solicitar la cuenta en dólares. Fácil, rápido y con un solo clic.'}></Info>
                                <Text fontSize={"14px"} fontWeight={400} lineHeight={"18px"}>Completá los datos y en breve nos pondremos en contacto con vos para que puedas consultar tus dudas y coordinar un turno. Una vez asignado vamos a esperarte en la sucursal, el día acordado, así podés concluir tu pedido</Text>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ComponenteCtaPersonaJuridicaPresolicitud />
                        </Box>
                    </Box> 
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>
                        El clic en ENVIAR implica mi conformidad para que los datos de esta presolicitud – sujeta a evaluación – sean remitidos, bajo las condiciones precedentemente informadas, al Banco de la Provincia de Buenos Aires, sin que ello importe su aceptación. Asimismo, declaro haber tomado conocimiento de los <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar/CDN/Get/TYC_BIP'>términos y condiciones para la utilización de Banca Internet Provincia</a> (BIP) y/o del sitio web del <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar/CDN/Get/Terminos_y_condiciones_Banco_Provincia'> Banco de la Provincia de Buenos Aires </a> los cuales pueden descargarse e imprimirse; así como también de haber obtenido toda la información necesaria para su correcta utilización, los riesgos derivados de su empleo y quien asume los mismos. Los documentos mencionados también se encuentran a disposición del sitio web del <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar'>Banco Provincia</a>
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}




